import { useState } from "react";
import TextInputWithTags from "@components/ui/text_input_with_tags.tsx";
import useTranslation from "@hooks/use_translation.ts";
import ModalFooter from "./modal_footer.tsx";
import useSectionSave from "./use_section_save.ts";
import type { SectionProps } from "./types.ts";

const MAX_SKILLS = 25;
const SKILL_MAX_LENGTH = 255;

const SkillsSection = ({ data, onClose, source }: SectionProps) => {
  const { t } = useTranslation("user", { keyPrefix: "profile_checklist.modals.skills" });
  const { save, saving, errors } = useSectionSave();

  const [skills, setSkills] = useState<string[]>(data.skills ?? []);

  const handleSave = async () => {
    const formData = new FormData();
    formData.append("skills", JSON.stringify(skills));

    const success = await save(formData);
    if (success) onClose();
    return success;
  };

  return (
    <>
      <TextInputWithTags
        id="skills-input"
        values={skills}
        onChange={setSkills}
        max={MAX_SKILLS}
        maxMessage={t("limit_reached")}
        addLabel={t("add")}
        placeholder={t("placeholder")}
        maxLength={SKILL_MAX_LENGTH}
        short
        error={errors.skills?.[0]}
      />
      <ModalFooter
        section="skills"
        onSave={handleSave}
        onCancel={onClose}
        saving={saving}
        source={source}
      />
    </>
  );
};

export default SkillsSection;
